import { ValueSetType } from "../Constants/ValueSetType";

class GetValuesRequest {
    public CountryCode: string;
    public ProvinceCode: string;
    public CityName: string;
    public AgentCode: string;
    public Type: ValueSetType[];

    public constructor(fields?: Partial<GetValuesRequest>) {
        Object.assign(this, fields);
    }
}

export { GetValuesRequest };
